import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { BankComponent } from './app/components/bank/bank-component';
import { appConfig } from './app/app.config';

bootstrapApplication(BankComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch(err => console.error(err));
